/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetCasesStatsParams = zod.object({
	start: zod.string(),
	end: zod.string()
});

export type GetCasesStatsParams = zod.input<typeof GetCasesStatsParams>;
export type GetCasesStatsParamsOutput = zod.output<typeof GetCasesStatsParams>;
